import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {CodebookModel} from '@/libs/Api';
import {CodebooksDataService} from '@/libs/codebooks/codebooks-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const codebooksStore = registerCrudStore<CodebookModel, CodebookModel>(BusinessModule.Codebook, new CodebooksDataService());
